import { render, staticRenderFns } from "./SalesTerritory.vue?vue&type=template&id=2a9baaf8&"
import script from "./SalesTerritory.vue?vue&type=script&lang=js&"
export * from "./SalesTerritory.vue?vue&type=script&lang=js&"
import style0 from "./SalesTerritory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports